
<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <div class="row justify-content-between align-items-between mx-3">

              <h5 class="card-title">Deployment Servers</h5>
              
              <div>
                  <base-button class="btn btn-primary" @click="modalDeploymentServers = true">Add</base-button>
	              <base-button class="btn btn-primary" @click="toggleView">Toggle View</base-button>
              </div>
              
              <modal :show.sync="modalDeploymentServers">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Add DeploymentServer</h5>
                </template>
                <div>
                  <form @submit.prevent>
  <base-input label="OwnerId" type="text" placeholder="Enter OwnerId" v-model="deploymentServerToAdd.ownerId"></base-input>
  <base-input label="DeploymentServerId" type="text" placeholder="Enter DeploymentServerId" v-model="deploymentServerToAdd.deploymentServerId"></base-input>
  <base-input label="DeploymentCloudId" type="text" placeholder="Enter DeploymentCloudId" v-model="deploymentServerToAdd.deploymentCloudId"></base-input>
  <base-input label="DeploymentUrl" type="text" placeholder="Enter DeploymentUrl" v-model="deploymentServerToAdd.deploymentUrl"></base-input>
  <base-input label="Hostname" type="text" placeholder="Enter Hostname" v-model="deploymentServerToAdd.hostname"></base-input>
  <base-input label="IpAddress" type="text" placeholder="Enter IpAddress" v-model="deploymentServerToAdd.ipAddress"></base-input>
  <base-input label="Password" type="text" placeholder="Enter Password" v-model="deploymentServerToAdd.password"></base-input>
                  </form>
                </div>
                <template slot="footer">
                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
                </template>
              </modal>
            </div>
          </template>
<div>
          <span class="table-title">DeploymentServers</span>
          <span>({{this.totalElements}})</span>
          <span><a-pagination
				      :current="pagination.current"
				      :total="pagination.total"
				      :pageSize="pagination.pageSize"
				      @change="onTableChange"
				      show-size-changer
				      :pageSizeOptions="['5','10', '20', '30', '40']"
				      @showSizeChange="handleSizeChange"
				    /></span>
</div>
			<div class="toggle-view">
				<base-button class="btn btn-primary" @click="toggleView">Toggle View</base-button>
			</div>

          <!-- Conditionally render the view based on the 'isTableView' flag -->
          <div v-if="isTableView">
            <!-- Render the existing Table View -->
            <a-table :columns="columnsBound" :data-source="deploymentServers" :row-key="record => record.DeploymentServerId" :pagination="pagination"
              :loading="searchLoading" @change="onTableChange" :scroll="{ x: 'max-content' }">

	              <template slot="deploymentServerId" slot-scope="dataIndex">
	              	<router-link  :to="`/deploymentServer/${dataIndex}`"><a >{{ dataIndex }}</a></router-link>
	              </template>



             <template slot="lastModified" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="createdOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="endedOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="blackOutStartDate" slot-scope="dataIndex">
              	{{ formatDate(dataIndex) }}
              </template>
            </a-table>
          </div>
          <div v-else>
            <!-- Render the Picture View  -->
            <DeploymentServerPictureView :deploymentServers="deploymentServers" />
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import DeploymentServerService from "../services/DeploymentServerService";
import { ASelect, ASelectOption, AButton, Table, Pagination } from "ant-design-vue";
import DeploymentServerPictureView from './DeploymentServerPictureView.vue';


const deploymentServersColumns = [
  "deploymentServerId",
  "deploymentServerId"
]

export default {
  props: {
    deploymentServers: {
      type: Array,
      required: true,
    },
    totalElements: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Modal,
    BaseButton,
    BaseInput,
    Table,

    Pagination,
    DeploymentServerPictureView
  },

  data() {
    return {
      modalDeploymentServers: false,
        isTableView: false,

      columns: [
        {
          title: 'Deployment Server Id',
		dataIndex: 'deploymentServerId',
          visible: true,
          scopedSlots: { customRender: 'deploymentServerId' },
          sorter: true
          //sorter: (a, b) => a.deploymentServerId - b.deploymentServerId,
          //sorter: (a, b) => a.deploymentServerId.localeCompare(b.deploymentServerId),
        },
        {
          title: 'Deployment Cloud Id',
		dataIndex: 'deploymentCloudId',
          visible: true,
          scopedSlots: { customRender: 'deploymentCloudId' },
          sorter: true
          //sorter: (a, b) => a.deploymentCloudId - b.deploymentCloudId,
          //sorter: (a, b) => a.deploymentCloudId.localeCompare(b.deploymentCloudId),
        },
        {
          title: 'Deployment Url',
		dataIndex: 'deploymentUrl',
          visible: true,
          scopedSlots: { customRender: 'deploymentUrl' },
          sorter: true
          //sorter: (a, b) => a.deploymentUrl - b.deploymentUrl,
          //sorter: (a, b) => a.deploymentUrl.localeCompare(b.deploymentUrl),
        },
        {
          title: 'Hostname',
		dataIndex: 'hostname',
          visible: true,
          scopedSlots: { customRender: 'hostname' },
          sorter: true
          //sorter: (a, b) => a.hostname - b.hostname,
          //sorter: (a, b) => a.hostname.localeCompare(b.hostname),
        },
        {
          title: 'Ip Address',
		dataIndex: 'ipAddress',
          visible: true,
          scopedSlots: { customRender: 'ipAddress' },
          sorter: true
          //sorter: (a, b) => a.ipAddress - b.ipAddress,
          //sorter: (a, b) => a.ipAddress.localeCompare(b.ipAddress),
        },
        {
          title: 'Password',
		dataIndex: 'password',
          visible: true,
          scopedSlots: { customRender: 'password' },
          sorter: true
          //sorter: (a, b) => a.password - b.password,
          //sorter: (a, b) => a.password.localeCompare(b.password),
        },
        {
          title: 'Owner Id',
		dataIndex: 'ownerId',
          visible: true,
          scopedSlots: { customRender: 'ownerId' },
          sorter: true
          //sorter: (a, b) => a.ownerId - b.ownerId,
          //sorter: (a, b) => a.ownerId.localeCompare(b.ownerId),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} deploymentServers`,
      },

      deploymentServers: [],
      deploymentServerToAdd: {},

      deploymentServersTable: {
        columns: [...deploymentServersColumns],
        data: [],
      },

      // New properties for sorting and searching
      sortBy: 'deploymentServerId',           // Column to sort by
      sortOrder: 'asc',     // Sort order (asc or desc)
      searchLoading: false, // Initialize searchLoading property


    };
  },

  watch: {
	  searchQuery: {
		handler: "handleSearchQueryChanged", // Call the fetchData method when searchQuery changes
		immediate: true, // Trigger immediately when the component is mounted
      },
	  page(newPage) {
	    this.pagination.current = newPage;
	  },
	  totalElements(newTotal) {
	    this.pagination.total = newTotal;
	  },
	  pageSize(newSize) {
	    this.pagination.pageSize = newSize;
	  },
  },

  methods: {

    async renderDeploymentServersTable() {
      this.searchLoading = true; // Set searchLoading to true while fetching data
      this.searchLoading = false;

      this.pagination.total = this.totalElements;
      this.pagination.current = this.page;

      let deploymentServersTableData = [];
      for (let i = 0; i < this.deploymentServers.length; i++) {
        deploymentServersTableData.push({
          id: i,
          deploymentServerId: this.deploymentServers[i].deploymentServerId,
          deploymentServerId: this.deploymentServers[i].deploymentServerId,
        });

      }
      this.searchLoading = false;
    },

	handleSizeChange(current, size) {
      
      this.pagination.pageSize = size;
      this.pagination.current = 1; // Reset to the first page
      
      this.$root.$emit('selectedPageSizeChanged', size);
      
    },	

async onTableChange(arg1, arg2, arg3) {
    // a-table path
    if (arg1 && typeof arg1 === 'object' && 'current' in arg1) {
      const pagination = arg1;
      const sorter = arg3 || {};

      this.pagination.current = Number(pagination.current) || 1;
      this.pagination.pageSize = Number(pagination.pageSize) || this.pagination.pageSize;

      if (sorter.field) {
        // Normalize sorter.order -> our state; if cleared/missing, pick a sensible next state
        const isNewField = sorter.field !== this.sortBy;
        const next =
          sorter.order === 'ascend'  ? 'asc'  :
          sorter.order === 'descend' ? 'desc' :
          isNewField                 ? 'asc'  : (this.sortOrder === 'asc' ? 'desc' : 'asc');

        this.sortBy = sorter.field;
        this.sortOrder = next;
      }
    } else {
      // header <a-pagination> path
      const page = Number(arg1);
      const size = Number(arg2);
      if (Number.isFinite(page)) this.pagination.current = page;
      if (Number.isFinite(size)) this.pagination.pageSize = size;
    }

    const current = Number(this.pagination.current) || 1;
    const size = Number(this.pagination.pageSize) || 50;
    this.$emit('get-all-deployment-servers', this.sortBy, this.sortOrder, current - 1, size);
  },
	
	initializeColumns() {
        this.columns = this.columns.filter(item => item.visible);
    },

    routingToUserDetail(id) {
      this.$router.push({ name: 'UserDetail', params: { userId: id.toString() }})
    },
    routingToDeploymentServerDetail(id) {
      this.$router.push({ name: 'DeploymentServerDetail', params: { deploymentServerId: id.toString() }})
    },
    routingToApplicationDetail(id) {
      this.$router.push({ name: 'ApplicationDetail', params: { applicationId: id.toString() }})
    },
    
    toggleView() {
      this.isTableView = !this.isTableView;
    },
	
	async handleAddSubmitted() {
      this.modalDeploymentServers = false;

      const currentDate = new Date().getTime();
      this.deploymentServerToAdd.created = currentDate;

      const jsonData = JSON.stringify(this.deploymentServerToAdd);
      console.log(jsonData);
      
      const res = await DeploymentServerService.addDeploymentServer(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},
	
	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
	computed: {
	  // feed the table columns with a UI sort state
	  columnsBound() {
	    const uiOrder = this.sortOrder === 'asc' ? 'ascend' : 'descend';
	    return this.columns
	      .filter(c => c.visible)
	      .map(c => ({
	        ...c,
	        key: c.key || c.dataIndex,
	        sorter: c.sorter ?? true,
	        sortDirections: ['ascend', 'descend'],   // no cleared state
	        sortOrder: c.dataIndex === this.sortBy ? uiOrder : null,
	      }));
	  },
	},
  mounted() {
  	this.initializeColumns();
    this.renderDeploymentServersTable();
  }
};
</script>

<style>
.modal-dialog {
  margin-top: -300px;
}
.ant-table-row  {
	text-align: center;
}
.ant-table-thead th span {
	text-align: center;
	width: 100%
}
.ant-table-fixed td span {
    text-align: center;
}

.table-title {
	font-size: 1.75rem;
	font-weight: bold;
	font-style: italic;
	color: rgb(52, 152, 219); 
	text-align: left;
	padding: 0px 15px;
}

.deploymentServer-link {
	color: #11ba81;
}

</style>
